import type { AutoBreakDeductionStatus } from './types';

type TimeEntryWithBreaks = {
  flair__Non_compliant__c?: boolean | null;
  breaks?: ReadonlyArray<{
    flair__Auto_adjusted_Datetime__c?: string | null;
  }> | null;
};

export const calculateBreakDeductionStatus = (
  timeEntries: ReadonlyArray<TimeEntryWithBreaks> | null | undefined,
): AutoBreakDeductionStatus => {
  if (!timeEntries || timeEntries.length === 0) {
    return undefined;
  }

  let hasAutoAdjustedBreaks = false;

  for (const timeEntry of timeEntries) {
    if (timeEntry.flair__Non_compliant__c === true) {
      return 'failed';
    }
    if (
      timeEntry.breaks?.some(
        (breakItem) => breakItem.flair__Auto_adjusted_Datetime__c != null,
      )
    ) {
      hasAutoAdjustedBreaks = true;
    }
  }

  return hasAutoAdjustedBreaks ? 'success' : undefined;
};

export const calculateBreakDeductionStatusForSingleEntry = (
  timeEntry: TimeEntryWithBreaks,
): AutoBreakDeductionStatus => {
  if (timeEntry.flair__Non_compliant__c === true) {
    return 'failed';
  }
  if (
    timeEntry.breaks?.some(
      (breakItem) => breakItem.flair__Auto_adjusted_Datetime__c != null,
    )
  ) {
    return 'success';
  }
  return undefined;
};
